import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import type { EmploymentType } from "~/modules/humanResources/api/employmentType/employmentTypeTypes.ts";

export const getAllEmploymentTypes = (): AxiosApiResponsePromise<EmploymentType[]> => axiosApi.get('employment-types');
